import $ from 'jquery';

const TARGET_CLASS = 'module-notes';
const LOADING_CLASS = `${TARGET_CLASS}--loading`;

$(function() {
    let $block = $(`.${TARGET_CLASS}`);

    if (!$block.length) {
        return
    }

    $block.on('change', `.${TARGET_CLASS}__input`, function() {
        let $input = $(this);
        let $_block = $input.parents(`.${TARGET_CLASS}`);

        if ($_block.hasClass(LOADING_CLASS)) {
            return;
        }

        $_block.addClass(LOADING_CLASS);

        let request = $.ajax({
            type: 'GET',
            url: (<any> window).Buckle.urls.ajax,
            data: {
                'action': 'update_user_notes',
                'id' : $input.data('id'),
                'notes' : $input.val(),
                '_nonce' : (<any> window).Buckle.vars._nonce,
            }
        });

        request.done(response => $_block.removeClass(LOADING_CLASS));

        request.fail((xhr, error) => {
            alert('There was an error updating your notes. Please notify a site administrator.');

            if ((<any> window).Buckle.vars.debug) {
                console.error(error);
            }
        });
    });
});



// WEBPACK FOOTER //
// ./resources/assets/scripts/components/ModuleNotes.ts